import React from 'react';

import ButtonPublic from '@shared/components/ui/ButtonPublic';
import raasLogo from '../../assets/thredup-raas-logo.png';
import { AUTH_HREF, NAV_LINKS } from '../../constants';

import styles from './styles.module.css';

import { track } from '@/shared/analytics/track';
import { useGlobalSettings } from '@/shared/hooks/useGlobalSettings';

const handleBookACallClick = (): void => {
  track('book_a_call_clicked', { location: 'top_nav' });
};

// beforeNavigation: this is a same-tab full-page navigation to /login, so a
// batched event would be lost when the document unloads.
const handleSignInClick = (): void => {
  track('sign_in_clicked', { location: 'top_nav' }, { beforeNavigation: true });
};

const TopNav: React.FC = () => {
  const { bookAMeetingUrl } = useGlobalSettings();

  return (
    <header className={styles.nav}>
      <div className={styles.inner}>
        {/* Landing-page section links. Absolute (`/#engage`) so they also work
            from the other public pages this nav renders on. */}
        <nav className={styles.links} aria-label="In-page sections">
          {NAV_LINKS.map((link) => (
            <a key={link.href} className={styles.link} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        {/* "/" rather than "#top": the mark should lead home from every public
            page, not scroll to the top of whichever one you're on. */}
        <a className={styles.brand} href="/" aria-label="ThredUp RaaS — home">
          <img
            className={styles.raasLogo}
            src={raasLogo}
            alt="ThredUp Resale-as-a-Service"
            width={1917}
            height={588}
          />
        </a>

        <div className={styles.cta}>
          <a
            className={styles.signin}
            href={AUTH_HREF}
            onClick={handleSignInClick}
          >
            Sign in
          </a>
          <ButtonPublic
            as="a"
            href={bookAMeetingUrl}
            target="_blank"
            variant="primary"
            size="sm"
            onClick={handleBookACallClick}
          >
            Book a call
          </ButtonPublic>
        </div>
      </div>
    </header>
  );
};

export default TopNav;
